
(function(){
  // сколько «чуть ниже фолда» считаем первым экраном
  const ABOVE_FOLD_MARGIN = 400; // px

  // элемент считается «на первом экране», если его верх находится выше границы фолда
  const isAboveFold = (el) => {
    const r = el.getBoundingClientRect();
    return r.top <= (window.innerHeight + ABOVE_FOLD_MARGIN);
  };

  // базовые атрибуты
  function prime(el, eager=false){
    if (el.tagName === 'IMG') {
      if (!el.loading) el.setAttribute('loading', eager ? 'eager' : 'lazy');
      if (!el.decoding) el.setAttribute('decoding', eager ? 'sync' : 'async');
      if (el.hasAttribute('srcset') && !el.hasAttribute('sizes')) el.setAttribute('sizes','100vw');
    } else if (el.tagName === 'IFRAME') {
      if (!el.loading) el.setAttribute('loading', eager ? 'eager' : 'lazy');
      if (!el.referrerPolicy) el.setAttribute('referrerpolicy','strict-origin-when-cross-origin');
    }
  }

  function activateImage(img){
    const pic = img.closest('picture');
    if (pic){
      pic.querySelectorAll('source[data-srcset]').forEach(s=>{
        s.srcset = s.dataset.srcset; s.removeAttribute('data-srcset');
      });
    }
    if (img.dataset.srcset){ img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    if (img.dataset.src){ img.src = img.dataset.src; img.removeAttribute('data-src'); }
    if (img.dataset.bg){ img.style.backgroundImage = 'url("'+img.dataset.bg+'")'; img.removeAttribute('data-bg'); }
  }
  function activateIframe(f){
    if (f.dataset.src){ f.src = f.dataset.src; f.removeAttribute('data-src'); }
  }
  function activate(el){
    if (el.__lazyDone) return;
    el.__lazyDone = true;
    if (el.tagName === 'IMG') activateImage(el);
    else if (el.tagName === 'IFRAME') activateIframe(el);
  }

  // собираем кандидатов внутри root
  function collect(root=document){
    const imgs = Array.from(root.querySelectorAll('img'));
    const ifr = Array.from(root.querySelectorAll('iframe'));
    return {imgs, ifr};
  }

  // наблюдатель
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries)=>{
    for (const e of entries){
      if (e.isIntersecting){ activate(e.target); io.unobserve(e.target); }
    }
  }, {root:null, rootMargin:'200px 0px', threshold:0}) : null;

  // обработка набора
  function processSet(set, initial=true){
    // IMG
    set.imgs.forEach(img=>{
      const eager = initial && isAboveFold(img);   // только на первом проходе определяем «первый экран»
      prime(img, eager);
      // если есть data-* источники — либо активируем сразу (если above-the-fold), либо лениво
      if (img.hasAttribute('data-src') || img.hasAttribute('data-srcset') || img.hasAttribute('data-bg')) {
        if (eager || !io) activate(img); else io.observe(img);
      }
    });
    // IFRAME
    set.ifr.forEach(f=>{
      const eager = initial && isAboveFold(f);
      prime(f, eager);
      if (f.hasAttribute('data-src')) {
        if (eager || !io) activate(f); else io.observe(f);
      }
    });
  }

  // начальная инициализация
  processSet(collect(), /*initial=*/true);

  // подхватываем динамические вставки (quick-add, Ajax sections и т.д.)
  const mo = new MutationObserver(muts=>{
    muts.forEach(m=>{
      m.addedNodes.forEach(node=>{
        if (node.nodeType !== 1) return;
        // сам узел
        if (node.matches?.('img,iframe')) processSet({imgs:[].filter.call([node], n=>n.tagName==='IMG'), ifr:[].filter.call([node], n=>n.tagName==='IFRAME')}, /*initial=*/false);
        // потомки
        processSet(collect(node), /*initial=*/false);
      });
    });
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();


// shop all жирным
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.header-sidebar__nested-linklist .link-faded-reverse')
      .forEach(function (a) {
        if (a.textContent.trim().toLowerCase() === 'shop all') {
          a.classList.add('link-faded-reverse--bold');
        }
      });
  });





//estimate delievery


var fromDate = Date.today().addDays(18);
if (fromDate.is().saturday() || fromDate.is().sunday()) {
fromDate = fromDate.next().monday();
}
var toDate = Date.today().addDays(27);
if (toDate.is().saturday() || toDate.is().sunday()) {
toDate = toDate.next().monday();
}
document.getElementById('fromDate').innerHTML = fromDate.toString('MMMM dS');
document.getElementById('toDate').innerHTML = toDate.toString('MMMM dS');

